import { Carousel } from "react-bootstrap";

const slides = [
  {
    id: "6c3bf1be1c6e988f448e4ac7169e1219146b73695cb6fe78903e4c8e514c69451",
    visualizationUrl:
      "https://www.snorkle.io/imageviewer/?name=https%3A//snorkle-output-files.s3.amazonaws.com//P824_LRL2_01_output/P824_LRL2_01_files/&width=5284&height=5925",
    title: "Vagus Nerve Histology",
    description: "",
    thumbnail:
      "https://snorkle-visuals.s3.amazonaws.com/snorkle_vis_thumbnails/vagus_nerve_image.png",
    qrUrl: "",
    uploadTime: 1654714121,
    style: "dark"
  },
  {
    id: "6c3bf1be1c70988f448e4ac7169e1219146b73695cb6fe78903e4c8e514c69452",
    visualizationUrl:
      "https://vis.snorkle.io/ODsNKT1Ds46K4-UKKNKpUTxmYKEY3aIB61pzxsqmaWU=/viewer.html",
    title: "Brain MRI",
    description: "",
    thumbnail:
    "https://snorkle-visuals.s3.amazonaws.com/snorkle_vis_thumbnails/brain_mri.png",
  uploadTime: 1654714121,
  style: "light"
  },
  {
    id: "6c3bf1be1c70988f448e4ac7169e1219146b73695cb6fe78903e4c8e514c69453",
    visualizationUrl:
      "https://snorkle-output-files.s3.amazonaws.com/model25d9bb5a5ff14f52958684e6c4880a56.html",
    title: "Arm Musculature",
    description: "",
    thumbnail:
      "https://snorkle-visuals.s3.amazonaws.com/snorkle_vis_thumbnails/arm_musculature.jpeg",
    uploadTime: 1654714121,
    style: "dark"
  },
  {
    id: "6c3bf1be1c70988f448e4ac7169e1219146b73695cb6fe78903e4c8e514c69453",
    visualizationUrl:
      "https://vis.snorkle.io/kMj6kPI82mJKMzMrksvvezOiPmkSKMCNfPxtRDVc41Y=/viewer.html",
    title: "Zebrafish Neuromast",
    description: "",
    thumbnail:
      "https://snorkle-visuals.s3.amazonaws.com/snorkle_vis_thumbnails/zebrafish_neuromast.png",
    uploadTime: 1654714121,
    style: "light"
  },
  {
    id: "6c3bf1be1c70988f448e4ac7169e1219146b73695cb6fe78903e4c8e514c69453",
    visualizationUrl:
      "https://vis.snorkle.io/e9-6yJ6kTLbpoglQN7hcCLO_Sa38mEeP_ymNagtUCUI=.html",
    title: "SARS-CoV-2 macrodomain in complex with remdesivir",
    description: "",
    thumbnail:
      "https://snorkle-visuals.s3.amazonaws.com/snorkle_vis_thumbnails/covid_spike_protein.png",
    uploadTime: 1654714121,
    style: "dark"
  },
  {
    id: "6c3bf1be1c70988f448e4ac7169e1219146b73695cb6fe78903e4c8e514c69453",
    visualizationUrl:
      "https://www.snorkle.io/imageviewer/?name=https%3A//snorkle-output-files.s3.amazonaws.com//N44_WFC3_ACS_mosaic_2b_output/N44_WFC3_ACS_mosaic_2b_files/&width=10000&height=13751",
    title: "N44 Emission Nebula, Hubble Space Telescope",
    description: "",
    thumbnail:
      "https://snorkle-visuals.s3.amazonaws.com/snorkle_vis_thumbnails/n44_emission.png",
    uploadTime: 1654714121,
    style: "light"
  },
];

const FeaturedViewers = (props) => {
  return (
    <Carousel variant="light" className={props.className} indicatorLabels={slides.map((slide)=> slide.title)}>
      {slides.map((slide, index) => {
        return (
          <Carousel.Item key={index}>
            <center>
            <a href={slide.visualizationUrl} rel="noreferrer" target="_blank">
              <img
                width="100%"
                height="auto"
                src={slide.thumbnail}
                alt={slide.title}
              />
              <Carousel.Caption className={"rounded text-"+slide.style}>
                <h3>{slide.title}</h3>
                <p>{slide.description}</p>
              </Carousel.Caption>
            </a>
            </center>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default FeaturedViewers;
